import {useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom'

import {useAbortableLoad} from '../../Hooks'


import "./style.css";
import DocumentSheduleEditor from "../../Components/DocumentSheduleEditor";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import SaveStatus from "../../UIComponents/SaveStatus/index.js";

import mapStateToProps from './mapStateToProps.js'
import {memo} from "react";


const DocumentSheduleOperation = ({ variant }) => {


  const { docId } = useParams();
  const {
    addingDocument,
    savingDocument,
    rights,
    // getSingleDocument = () => { },
    addDocument = () => { },
    saveDocument = () => { },
    setSingleDocument = () => { },
  } = useSelector(mapStateToProps)

  const singleDocument = useAbortableLoad(
    'getSingleDocument',
    'singleDocument',
    { docId: "planSchedule", id: docId },
    variant !== 'add',
    [docId, variant !== 'add'],
    'setSingleDocument'
  ) || {};

  const {
    data: {
      id: { rawValue: id } = {},
      number: { rawValue: number } = {},
      date: { rawValue: date = new Date().valueOf() } = {},
      company: { rawValue: company } = {},
      project: { rawValue: project } = {},
      periodFrom: { rawValue: periodFrom = new Date().valueOf() } = {},
      periodTo: { rawValue: periodTo = new Date().valueOf() } = {},
      status: { value: demoStatus } = {},
      status: { rawValue: rawStatus } = {},
      availableStatuses: { rawValue: availableStatuses } = {},//мусор
      prepared_by: { value: prepared_by } = {},//ридонли
      carried_out: { rawValue: carried_out = false } = {},
      dataArr: dataArrIncoming = []
    } = {},
  } = singleDocument;


  const dataArr = dataArrIncoming?.map((item) => {
    const {
      id: { rawValue: id } = {},
      number: { rawValue: number } = {},
      plan: { rawValue: plan } = {},//мусор
      workType: { rawValue: workType } = {},
      scope: { rawValue: scope } = {},
      start: { rawValue: start } = {},
      end: { rawValue: end } = {},
      processRequirements: { rawValue: processRequirements } = {},
      resultRequirements: { rawValue: resultRequirements } = {},
    } = item
    return {
      id,
      number,
      plan,
      workType,
      scope,
      start,
      end,
      processRequirements,
      resultRequirements,
    }
  })

  const fields = {
    id,
    number,
    date,
    company,
    project,
    demoStatus,
    rawStatus,
    periodFrom,
    periodTo,
    prepared_by,
    carried_out,
    dataArr,
    isView: (variant === 'view')
  }

  /**Признак того, что все данные формы готовы к работе */
  const isReady = (variant === 'add') || (singleDocument && !singleDocument?.loading);

  const history = useHistory()

  let saver = () => { };
  if (variant === "edit") {
    saver = (fields) => {
      saveDocument({
        docId: "planSchedule",
        fields
      })
    }

  } else if (variant === "add") {
    saver = (fields) => {
      addDocument({
        docId: "planSchedule",
        fields
      })
    }
  }

  const postSaveAction = () => {
    history.push('/document/schedule')
  }

  //правовые предохранители
  if (variant === 'add' && !rights?.['plan-create']) return null;
  if (variant === 'edit' && !rights?.['plan-edit']) return null;
  if (variant === 'view' && !rights?.['plan-view']) return null;

  return (
    <ContentContainer
      content={
        <>
          <SaveStatus dataObj={singleDocument} errShowTime={1000} successShowTime={100} />
          {isReady ? (
            <DocumentSheduleEditor
              clearer={() => setSingleDocument(undefined)}
              variant={variant}
              saver={saver}
              rights={rights}
              fields={fields}
              postSaveAction={postSaveAction}
              addingDocument={addingDocument}
              savingDocument={savingDocument}
            />
          ) : null}
        </>
      }
    />

  )
}

export default memo(DocumentSheduleOperation)
